import { Checkbox, FormControlLabel, FormHelperText, Grid, InputLabel, Radio, RadioGroup } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import {
    DatePicker,
    formatters,
    NoButton,
    PrimaryButton,
    SecondaryButton,
    SecondaryCheckbox,
    SelectBox,
    SingleSelect,
    TextBox,
    YesButton
} from '../../../../../Core/Controls';
import { reactCSS } from 'reactcss';
import {
    getPenaltyCharges,
    getPenaltyChargesScreenDropdowns,
    postPenaltyCharges
} from '../../../../../Core/Services/InternalUser/ControllerService/penaltyCharges-Service';
import { getDriverBasedOnCustndDepot } from '../../../../../Core/Services/Admin/userService';
import { getDriverList } from '../../../../../Core/Services/InternalUser/Vehicle/driverInfoService';
import { useToast } from '../../../../../Core/Hooks/useToast';

const statusList = [
    { id: 1, name: 'Unpaid' },
    { id: 2, name: 'Appeal' },
    { id: 3, name: 'Paid' }
];

const AddUpdatePenalty = (props) => {
    const { showToastWarning, showToastError, showToastSuccess } = useToast();

    const [penaltyDetails, setPenaltyDetails] = useState({
        amount: '',
        reason: '',
        date: '',
        penaltyChargeID: null,
        penaltyChargeReference: '',
        penaltyChargeDescription: '',
        penaltyChargeRegNumber: props.selectedRegNo,
        penaltyChargeDateReceived: '',
        penaltyChargeOffenceDate: '',
        penaltyChargeAppealEndDate: '',
        penaltyChargeApealed: '',
        penaltyChargeAppealDate: '',
        penaltyChargePaidDate: '',
        penaltyChargePayByDate: '',
        penaltyChargeCost: '',
        penaltyChargeIssuingAuthority: '',
        penaltyChargePaidBy: '',
        penaltyChargeStatusID: 1,
        penaltyChargevDriverID: props.driverID || ''
    });
    const [dropDown, setdropDown] = useState({
        driverList: [],
        statusList: []
    });
    const [errors, setErrors] = useState({});

    const [tempOptions, setTempOptions] = useState({
        penaltyChargevDriverID: null
    });

    // useEffect(() => {
    //     const fetchDrivers = async () => {
    //         // if (props.VehicleID) {
    //         let res = await getDriverList(props.VehicleID, props.driverID);
    //         if (res.success) {
    //             setdropDown((st) => ({
    //                 ...st,
    //                 driverList: res.data.details.map((m) => ({
    //                     id: m.driverID,
    //                     name: m.driver
    //                 }))
    //             }));
    //         }
    //         // }
    //     };
    //     fetchDrivers();
    // }, []);
    useEffect(() => {
        const fetchDrivers = async () => {
            let res = await getPenaltyChargesScreenDropdowns(props.VehicleID);
            if (res.success) {
                setdropDown((st) => ({
                    ...st,
                    statusList: res.data.status,
                    driverList: res.data.drives
                }));
            }
        };
        fetchDrivers();
    }, []);

    useEffect(() => {
        const fetchPenaltyDetails = async () => {
            if (props.selectedRow?.penaltyChargeID) {
                let res = await getPenaltyCharges(props.selectedRow.penaltyChargeID);
                console.log(res, 'res');
                let data = res.data.list[0];
                setPenaltyDetails((prevDetails) => ({
                    ...prevDetails,
                    penaltyChargeID: data.penaltyChargeID,
                    penaltyChargeReference: data.penaltyChargeReference,
                    penaltyChargeDescription: data.penaltyChargeDescription,
                    // penaltyChargeRegNumber: data.penaltyChargeRegNumber,
                    penaltyChargeDateReceived: formatters.DateFormatter(data.penaltyChargeDateReceived),
                    penaltyChargeOffenceDate: formatters.DateFormatter(data.penaltyChargeOffenceDate),
                    penaltyChargeAppealEndDate: formatters.DateFormatter(data.penaltyChargeAppealEndDate),
                    penaltyChargeAppealDate: formatters.DateFormatter(data.penaltyChargeAppealDate),
                    penaltyChargePaidDate: formatters.DateFormatter(data.penaltyChargePaidDate),
                    penaltyChargePayByDate: formatters.DateFormatter(data.penaltyChargePayByDate),
                    penaltyChargeApealed: data.penaltyChargeApealed,
                    penaltyChargeCost: data.penaltyChargeCost,
                    penaltyChargeIssuingAuthority: data.penaltyChargeIssuingAuthority,
                    penaltyChargePaidBy: data.penaltyChargePaidBy,
                    penaltyChargeStatusID: data.penaltyChargeStatusID,
                    penaltyChargevDriverID: data.penaltyChargevDriverID || props.driverID
                }));
            }
        };
        fetchPenaltyDetails();
    }, []);

    useEffect(() => {
        if (penaltyDetails.penaltyChargevDriverID && dropDown.driverList.length > 0) {
            let selectedDriver = dropDown.driverList.find((e) => e.id === penaltyDetails.penaltyChargevDriverID);

            setTempOptions((st) => ({
                ...st,
                penaltyChargevDriverID: selectedDriver
            }));
        }
    }, [dropDown.driverList, penaltyDetails.penaltyChargevDriverID]);

    console.log(penaltyDetails.penaltyChargeID, 'PenaltyChargeID');

    const handleChange = (e) => {
        const { name, value } = e.target;

        setPenaltyDetails((st) => {
            const nst = { ...st, [name]: value };
            if (name === 'penaltyChargeStatusID' && value == 2) {
                nst.penaltyChargeApealed = true;
            }

            return nst;
        });
    };

    const validations = () => {
        let formIsValid = true;
        let errors = {};
        if (!penaltyDetails.penaltyChargeReference) {
            errors.penaltyChargeReference = ' This field is required';
            formIsValid = false;
        }
        if (!penaltyDetails.penaltyChargeIssuingAuthority) {
            errors.penaltyChargeIssuingAuthority = ' This field is required';
            formIsValid = false;
        }
        if (!penaltyDetails.penaltyChargeCost) {
            errors.penaltyChargeCost = ' This field is required';
            formIsValid = false;
        }
        if (!penaltyDetails.penaltyChargeAppealDate && penaltyDetails.penaltyChargeApealed) {
            errors.penaltyChargeAppealDate = ' This field is required';
            formIsValid = false;
        }
        if (!penaltyDetails.penaltyChargePaidDate && penaltyDetails.penaltyChargeStatusID == 3) {
            errors.penaltyChargePaidDate = ' This field is required';
            formIsValid = false;
        }

        setErrors((state) => ({ ...state, ...errors }));
        return formIsValid;
    };

    const handleSubmit = async () => {
        if (!validations()) return;

        const { VehicleID, onClose } = props;

        const data = {
            penaltyChargeID: penaltyDetails.penaltyChargeID ?? null,
            penaltyChargeVehicleID: VehicleID ?? null,
            penaltyChargevDriverID: tempOptions.penaltyChargevDriverID?.id ?? props.driverID,
            penaltyChargeReference: penaltyDetails.penaltyChargeReference ?? '',
            penaltyChargeDescription: penaltyDetails.penaltyChargeDescription ?? '',
            penaltyChargeRegNumber: penaltyDetails.penaltyChargeRegNumber ?? '',
            penaltyChargeDateReceived: penaltyDetails.penaltyChargeDateReceived ?? '',
            penaltyChargeOffenceDate: penaltyDetails.penaltyChargeOffenceDate ?? '',
            penaltyChargeAppealEndDate: penaltyDetails.penaltyChargeAppealEndDate ?? '',
            penaltyChargeApealed: penaltyDetails.penaltyChargeApealed ?? false,
            penaltyChargeAppealDate: penaltyDetails.penaltyChargeAppealDate ?? '',
            penaltyChargePaidDate: penaltyDetails.penaltyChargePaidDate ?? '',
            penaltyChargeCost: penaltyDetails.penaltyChargeCost ?? 0,
            penaltyChargeIssuingAuthority: penaltyDetails.penaltyChargeIssuingAuthority ?? '',
            penaltyChargePayByDate: penaltyDetails.penaltyChargePayByDate ?? '',
            penaltyChargeStatusID: penaltyDetails.penaltyChargeStatusID ?? 1,
            penaltyChargePaidBy: 0
        };

        console.log(data, 'Submitting Penalty Charge');

        try {
            const res = await postPenaltyCharges(data);
            if (res.success) {
                onClose(true);
                showToastSuccess(res.message);
            } else {
                showToastError(res.message);
            }
        } catch (error) {
            console.error('Submission error:', error);
            showToastError('Something went wrong while submitting. Please try again.');
        }
    };

    const singleSelectChange = (nm) => (ev, val) => {
        // setTempOptions((st) => ({ ...st, [nm]: val }));
        setTempOptions((st) => {
            let newSt = { ...st, [nm]: val };
            if (nm === 'penaltyChargevDriverID') {
                newSt.depotsIDValue = null;
            }

            return newSt;
        });
    };

    const handleCheckbox = useCallback((e) => {
        const { name, checked } = e.target;
        setPenaltyDetails((st) => {
            const nst = { ...st, [name]: checked };
            return nst;
        });
    }, []);

    const handleActive = (val) => {
        setPenaltyDetails((field) => ({
            ...field,
            penaltyChargeApealed: val
        }));
    };

    return (
        <div>
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} sm={6} md={4} lg={3} className="mandatory-fields">
                    <InputLabel shrink required>
                        Reference
                    </InputLabel>
                    <TextBox name="penaltyChargeReference" value={penaltyDetails.penaltyChargeReference} onChange={handleChange} required autoFocus={true} />
                    <FormHelperText error>{errors.penaltyChargeReference}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={9} className="mandatory-fields">
                    <InputLabel shrink required>
                        Issuing Authority
                    </InputLabel>
                    <TextBox name="penaltyChargeIssuingAuthority" value={penaltyDetails.penaltyChargeIssuingAuthority} onChange={handleChange} required />
                    <FormHelperText error>{errors.penaltyChargeIssuingAuthority}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel shrink>Received Date</InputLabel>
                    <DatePicker name="penaltyChargeDateReceived" value={penaltyDetails.penaltyChargeDateReceived} onChange={handleChange} required />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel shrink>Offence Date</InputLabel>
                    <DatePicker name="penaltyChargeOffenceDate" value={penaltyDetails.penaltyChargeOffenceDate} onChange={handleChange} required />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel shrink>Pay By Date</InputLabel>
                    <DatePicker name="penaltyChargePayByDate" value={penaltyDetails.penaltyChargePayByDate} onChange={handleChange} required />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} className={penaltyDetails.penaltyChargeStatusID == 3 ? 'mandatory-fields' : ''}>
                    <InputLabel shrink required={penaltyDetails.penaltyChargeStatusID == 3}>
                        Paid Date
                    </InputLabel>
                    <DatePicker name="penaltyChargePaidDate" value={penaltyDetails.penaltyChargePaidDate} onChange={handleChange} required />
                    <FormHelperText error>{errors.penaltyChargePaidDate}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={6} md={12} lg={9}>
                    <InputLabel shrink>Driver</InputLabel>

                    <SingleSelect
                        options={dropDown.driverList}
                        value={tempOptions.penaltyChargevDriverID}
                        onChange={singleSelectChange('penaltyChargevDriverID')}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3} className="mandatory-fields">
                    <InputLabel shrink required>
                        Cost
                    </InputLabel>
                    <TextBox name="penaltyChargeCost" value={penaltyDetails.penaltyChargeCost} onChange={handleChange} required />
                    <FormHelperText error>{errors.penaltyChargeCost}</FormHelperText>
                </Grid>

                <Grid item xs={12} sm={8} md={9} lg={8}>
                    <InputLabel shrink>Description</InputLabel>
                    <TextBox
                        multiline
                        rows={5}
                        name="penaltyChargeDescription"
                        value={penaltyDetails.penaltyChargeDescription}
                        onChange={handleChange}
                        required
                    />
                    <FormHelperText error>{errors.penaltyChargeDescription}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg={4}>
                    <InputLabel shrink>Status</InputLabel>
                    {/* <SelectBox name="penaltyChargeStatusID" value={penaltyDetails.penaltyChargeStatusID} onChange={handleChange} List={statusList} /> */}
                    <RadioGroup
                        row
                        aria-label="penaltyChargeStatusID"
                        name="penaltyChargeStatusID"
                        value={+penaltyDetails.penaltyChargeStatusID}
                        onChange={handleChange}
                    >
                        {dropDown.statusList.map((item) => (
                            <FormControlLabel key={item.id} value={item.id} control={<Radio />} label={item.name} />
                        ))}
                    </RadioGroup>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                    <InputLabel shrink>Appeal</InputLabel>
                    <Grid item container spacing={2}>
                        <Grid item xs>
                            <YesButton state={penaltyDetails.penaltyChargeApealed} onClick={() => handleActive(true)}></YesButton>
                        </Grid>
                        <Grid item xs>
                            <NoButton state={penaltyDetails.penaltyChargeApealed} onClick={() => handleActive(false)}></NoButton>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4} className={penaltyDetails.penaltyChargeApealed ? 'mandatory-fields' : ''}>
                    <InputLabel shrink required={penaltyDetails.penaltyChargeApealed}>
                        Appeal Date
                    </InputLabel>
                    <DatePicker
                        name="penaltyChargeAppealDate"
                        value={penaltyDetails.penaltyChargeAppealDate}
                        onChange={handleChange}
                        required
                        disabled={!penaltyDetails.penaltyChargeApealed}
                    />
                    <FormHelperText error>{errors.penaltyChargeAppealDate}</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                    <InputLabel shrink>Appeal End Date</InputLabel>
                    <DatePicker
                        name="penaltyChargeAppealEndDate"
                        value={penaltyDetails.penaltyChargeAppealEndDate}
                        onChange={handleChange}
                        required
                        disabled={!penaltyDetails.penaltyChargeApealed}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={2} style={{ marginBottom: 10 }}>
                        <Grid item xs={6}>
                            <PrimaryButton onClick={handleSubmit}>Submit</PrimaryButton>
                        </Grid>
                        <Grid item xs={6}>
                            <SecondaryButton onClick={() => props.onClose(false)}>Cancel</SecondaryButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default AddUpdatePenalty;
